class SubscriptionPackage {
  constructor(title = null, description = null, hasSubscription = null, variants = null) {
    this.title = title;
    this.description = description;
    this.has_subscription = hasSubscription;
    this.hasSubscription = hasSubscription;
    this.variants = variants;
  }

  static fromJson(p) {
    return new SubscriptionPackage(
      p.title,
      p.description,
      p.has_subscription,
      p.variants,
    );
  }

  get variantsToDisplay() {
    const newArray = JSON.parse(JSON.stringify(this.variants)); // create a new array from the vue object
    for (let i = 0; i < newArray.length; i++) {
      newArray[i].prices = newArray[i].prices.filter((price) => price.is_archived === false);
    }
    return newArray;
  }

  getSubscribedPrice() {
    let price = null;
    this.variants.forEach((variant) => {
      variant.prices.forEach((item) => {
        if (item.has_subscription) {
          price = item;
        }
      });
    });

    return price;
  }

  static isPriceDiscountable(price, currentPromocode) {
    return price.promocode_data.is_discountable && price.promocode_data.applicable_promocode && price.promocode_data.applicable_promocode.code === currentPromocode.code;
  }
}

export default SubscriptionPackage;
